<template>
  <div>
    <div class="gd-label big gd-text-right gd-hidden-sm" v-if="!setCroppedImg().length">
      Entourez une donnée <IconChevronRight class="gd-typo-icon"></IconChevronRight>
    </div>
    <div class="gd-file-viewer__cropped-img-container">
      <img
        v-if="setCroppedImg().length > 0"
        :src=setCroppedImg()
        :style="{'width': getCroppedImageWidth(), 'height': getCroppedImageHeight()}"
        alt="Zone selectionée">
    </div>
    <form id="addMetaForm" @submit.prevent="validateForm(saveMetadata)">
      <div>
        <!--liste pour les type de metadonnée-->
        <label for="metaType" class="gd-label big">
          Type de la métadonnée :
        </label>
        <select
          name="metaType"
          id="metaType"
          required
          v-model="metaValueSelect"
          class="gd-select">
          <option
            v-for="metaType in metadatasType"
            :value="metaType.id"
            :disabled="metaType.isDisabled"
            :key="`meta${metaType.tagName}`">
            {{ metaType.friendlyName }}
          </option>
        </select>
        <br>
        <div class="ui error message" v-show="errors.has('metaType')">
          <p>{{ errors.first('metaType') }}</p>
        </div>
        <!--ajouter un PREFIX-->
        <input
          id="metaHasPrefix"
          name="metaHasPrefix"
          type="checkbox"
          class="gd-checkbox"
          v-model="metadataWithPosition.hasPrefix"
          v-on:change="resetTested">
        <label for="metaHasPrefix" class="gd-label big">
          Ajouter un préfix (sensible à la casse)
        </label>

        <div v-if="metadataWithPosition.hasPrefix">
          <input name="prefix"
           v-model="metadataWithPosition.prefixValue"
           v-validate="{rules: {required: this.metadataWithPosition.hasPrefix}}"
           placeholder="Préfix dans la zone sélectionnée"
           class="gd-input-text gd-input-text--full-width"
           :class="{ 'is-danger' : errors.has('prefix') }">

          <span v-show="errors.has('prefix')" class="help is-danger">
            {{ errors.first('prefix') }}
          </span>
        </div>
        <br>

        <!--ajouter une REGEX-->
        <input
          id="metaHasRegex"
          name="metaHasRegex"
          type="checkbox"
          class="gd-checkbox"
          v-model="metadataWithPosition.hasRegex"
          v-on:change="resetTested"/>
        <label for="metaHasRegex" class="gd-label big">Ajouter une regex </label>

        <div v-if="metadataWithPosition.hasRegex">
          <input name="regex"
                 v-model="metadataWithPosition.regexValue"
                 placeholder="Regex pour extraire la donnée"
                 :v-validate="{rules:
              {required: metadataWithPosition.hasRegex, checkregex: true}
            }"
                 class="gd-input-text gd-input-text--full-width"
                 :class="{ 'is-danger' : errors.has('regex') }">

          <span v-show="errors.has('regex')" class="help is-danger">
            {{ errors.first('regex') }}
          </span>
        </div>

        <!--ajouter un PATTERN TRANSFORM-->
        <p v-if="metadataWithPosition.transformPatterns.length > 0">
          <b>Transformations appliqués au résultat : </b>
        </p>
        <div v-for="(tranformPattern, index) in metadataWithPosition.transformPatterns"
             :key="`transformPattern${index}`">
          <label :for="`lookFor${index}`">Rechercher</label>
          <input
            :id="`lookFor${index}`"
            :name="`transformPattern${index}`"
            placeholder="Regex de recherche"
            v-model="tranformPattern.lookFor"
            class="gd-input-text gd-input-text--full-width"/>

          <label :for="`repalceWith${index}`">Remplacer par</label>
          <input
            :id="`repalceWith${index}`"
            :name="`transformPattern2${index}`"
            placeholder="Regex de remplacement"
            v-model="tranformPattern.replaceWith"
            class="gd-input-text gd-input-text--full-width"/>
        </div>
        <button
          @click.prevent="metadataWithPosition.transformPatterns.push({lookFor:'',replaceWith:''})">
          Ajouter un pattern de transformation
        </button>
      </div>
      <div class="gd-text-center">
        <input v-if="isUpdate"
          class="gd-default-btn"
          type="button"
          id="cancelIt"
          v-on:click="resetForm"
          value="Annuler">
        <input
          class="gd-default-btn"
          type="button"
          id="testMetadataButton"
          v-on:click="testMetadata"
          value="Tester">
      </div>
      <br>
      <i class="loader loader--medium loader--relative loader--light" v-if="loadingTest"></i>
      <div v-if="testedNoContent && !loadingTest" class="resultContainer">
        <p>Aucun résultat</p>
      </div>
      <div v-if="tested && !loadingTest" class="resultContainer">
        <div class="gd-label big">Résultat du test :</div>
        <div v-html="metadataWithPosition.testedValue" class="gd-file-viewer__results"></div>
        <input
          class="gd-default-btn gd-default-btn--full-width"
          type="submit"
          value="Valider la métadonnée">
      </div>
    </form>
  </div>
</template>

<script>
import IconChevronRight from '@/assets/svg/icon-chevron-right.svg';

import { mapActions } from 'vuex';
import { eventBus } from '../main';

export default {
  name: 'metadata-adder',

  components: {
    IconChevronRight,
  },

  data() {
    return {
      metadatasType: [
        { id: 1, tagName: 'siret', friendlyName: 'Siret', isDisabled: false },
        { id: 2, tagName: 'nirNumber', friendlyName: 'Numéro de sécurité sociale', isDisabled: false },
        { id: 3, tagName: 'periodStartDate', friendlyName: 'Début de période', isDisabled: false },
        { id: 4, tagName: 'periodEndDate', friendlyName: 'Fin de période', isDisabled: false },
        { id: 5, tagName: 'matricule', friendlyName: 'Matricule (ancien eDocFactory)', isDisabled: false },
        { id: 57, tagName: 'siren', friendlyName: 'Siren', isDisabled: false },
        { id: 55, tagName: 'empRegistrationNumber', friendlyName: 'Matricule', isDisabled: false },
        { id: 56, tagName: 'empRegistrationNumberStrict', friendlyName: 'Numéro de matricule (strict)', isDisabled: false },
        { id: 60, tagName: 'create-emp-from-siret-and-matricule', friendlyName: 'Création d\'employé en fonction du SIRET et du matricule sans numéro de sécu', isDisabled: false },
        { id: 50, tagName: 'empFirstName', friendlyName: 'Prénom du salarié', isDisabled: false },
        { id: 51, tagName: 'empName', friendlyName: 'Nom du salarié', isDisabled: false },
        { id: 52, tagName: 'empAddressStreet', friendlyName: 'Adresse (rue) du salarié', isDisabled: false },
        { id: 53, tagName: 'empAddressPostal', friendlyName: 'Code postal du salarié', isDisabled: false },
        { id: 54, tagName: 'empAddressCity', friendlyName: 'Ville du salarié', isDisabled: false },
        { id: 6, tagName: 'eFactureDocumentId', friendlyName: 'Identifiant de document eFacture', isDisabled: false },
        { id: 7, tagName: 'email', friendlyName: 'Email du destinatire', isDisabled: false },
        { id: 8, tagName: 'htTotalAmount', friendlyName: 'Total HT', isDisabled: false },
        { id: 9, tagName: 'tvaTotalAmount', friendlyName: 'Total TVA', isDisabled: false },
        { id: 10, tagName: 'ttcTotalAmount', friendlyName: 'Total TTC', isDisabled: false },
        { id: 59, tagName: 'montantNetAPayer', friendlyName: 'Montant Net à payer', isDisabled: false },
        { id: 11, tagName: 'issuerDepotProofFileId', friendlyName: 'Identifiant de l\'accusé de dépôt pour l\'issuer', isDisabled: false },
        { id: 12, tagName: 'senderDepotProofFileId', friendlyName: 'Identifiant de l\'accusé de dépôt pour le sender', isDisabled: false },
        { id: 13, tagName: 'coffreoFileId', friendlyName: 'Identifiant coffreo sur le fichier', isDisabled: false },
        { id: 14, tagName: 'cecurityFileIdForIssuer', friendlyName: 'Identifiant cecurity sur le fichier pour l\'issuer', isDisabled: false },
        { id: 15, tagName: 'cecurityFileIdForRecipient', friendlyName: 'Identifiant cecurity sur le fichier pour le destinataire', isDisabled: false },
        { id: 16, tagName: 'cecurityFileIdForSender', friendlyName: 'Identifiant cecurity sur le fichier pour le sender', isDisabled: false },
        { id: 17, tagName: 'documentPerimeter', friendlyName: 'Périmètre du document', isDisabled: false },
        { id: 18, tagName: 'documentSharedTreePath', friendlyName: 'Path du document en mode arborescence partagée', isDisabled: false },
        { id: 19, tagName: 'nantesMetropoleService', friendlyName: 'Service concerné de nantes métropole', isDisabled: false },
        { id: 20, tagName: 'nantesMetropoleMarket', friendlyName: 'Marché concerné de Nantes métropole', isDisabled: false },
        { id: 21, tagName: 'referenceClient', friendlyName: 'Référence client', isDisabled: false },
        { id: 22, tagName: 'cubdxConvocationDate', friendlyName: 'Date de convocation pour la CUB', isDisabled: false },
        { id: 23, tagName: 'jdclServiceName', friendlyName: 'Nom de service Je Declare', isDisabled: false },
        { id: 24, tagName: 'jdclServiceId', friendlyName: 'Identifiant de service Je Declare', isDisabled: false },
        { id: 25, tagName: 'ecTreePosition', friendlyName: 'Position dans l\'arbre expert comptable', isDisabled: false },
        { id: 26, tagName: 'invoiceDate', friendlyName: 'Date de facture', isDisabled: false },
        { id: 27, tagName: 'invoiceAmount', friendlyName: 'Montant de facture', isDisabled: false },
        { id: 28, tagName: 'edocParaphReference', friendlyName: 'Référence du document dans le parapheur', isDisabled: false },
        { id: 29, tagName: 'employeeCategorie', friendlyName: 'Catégorie', isDisabled: false },
        { id: 30, tagName: 'invoiceNumber', friendlyName: 'Numéro de facture', isDisabled: false },
        { id: 31, tagName: 'lrarUniqueNumber', friendlyName: 'Numéro de recommandé', isDisabled: false },
        { id: 33, tagName: 'linkedDocuments', friendlyName: 'Document lié', isDisabled: false },
        { id: 34, tagName: 'lrarTransmitSens', friendlyName: 'Sens de transmission de lettre recommandée', isDisabled: false },
        { id: 35, tagName: 'edocSafeStoreAndFileId', friendlyName: 'default friendly edocSafeStoreAndFileId', isDisabled: false },
        { id: 36, tagName: 'ocrDocType', friendlyName: 'Document type', isDisabled: false },
        { id: 37, tagName: 'recipientValue', friendlyName: 'Identifiant destinataire', isDisabled: false },
        { id: 38, tagName: 'recipientType', friendlyName: 'Type de destinataire', isDisabled: false },
        { id: 39, tagName: 'docDescription', friendlyName: 'Description du document', isDisabled: false },
        { id: 40, tagName: 'chorusNumEngagement', friendlyName: 'Numéro d\'engagement', isDisabled: false },
        { id: 41, tagName: 'chorusNumService', friendlyName: 'Numéro de service', isDisabled: false },
        { id: 42, tagName: 'chorusGuichetUserId', friendlyName: 'Identifiant CPP Guichet de l\'émetteur', isDisabled: false },
        { id: 43, tagName: 'chorusSiretFournisseur', friendlyName: 'Siret du fournisseur chorus', isDisabled: false },
        { id: 44, tagName: 'invoiceYear', friendlyName: 'Date de facture (année)', isDisabled: false },
        { id: 45, tagName: 'invoiceLabel', friendlyName: 'Libellé de la facture', isDisabled: false },
        { id: 46, tagName: 'invoiceType', friendlyName: 'Type de facture', isDisabled: false },
        { id: 47, tagName: 'farmCode', friendlyName: 'Code de l\'exploitation agricole', isDisabled: false },
        { id: 48, tagName: 'invoiceFormat', friendlyName: 'Format de facture', isDisabled: false },
        { id: 49, tagName: 'nmemoCode', friendlyName: 'Code NMemo', isDisabled: false },
        { id: 58, tagName: 'raisonSocialeEmetteur', friendlyName: 'Raison sociale de l\'émetteur', isDisabled: false },
        { id: 61, tagName: 'partnershipReferenceName', friendlyName: 'Raison sociale de l\'émetteur', isDisabled: false },
      ],
      metadataWithPosition: {
        hasPrefix: false,
        prefixValue: '',
        hasRegex: false,
        regexValue: '',
        transformPatterns: [],
        testedValue: '',
      },
      metadataWithPositionModel: {
        hasPrefix: false,
        prefixValue: '',
        hasRegex: false,
        regexValue: '',
        transformPatterns: [],
        testedValue: '',
      },
      metaValueSelect: -1,
      tested: false,
      testedNoContent: false,
      testedValueCss: {
        width: '100%',
        heigth: this.getCroppedImageHeight(),
      },
      loadingTest: false,
      isUpdate: false,
    };
  },

  created() {
    const dict = {
      custom: {
        prefix: {
          required: 'Le préfix est vide.',
        },
        regex: {
          required: 'La REGEX est vide.',
          checkregex: 'La REGEX semble invalide.',
        },
      },
    };

    this.$validator.localize('fr', dict);

    const checkRegex = (value) => {
      try {
        /* eslint-disable-next-line */
        new RegExp(value);
        return true;
      } catch (e) {
        return false;
      }
    };
    this.$validator.extend('checkregex', checkRegex);
  },

  props: {
    croppedSrcRef: String,
    location: {
      type: Object,
      default: () => ({
        x: '',
        y: '',
        width: '',
        height: '',
      }),
    },
  },

  watch: {
    location() {
      this.tested = false;
    },
  },

  methods: {
    ...mapActions({
      apiTestMetadata: 'lad/testMetadata',
    }),

    applyDisableForUpdate(fileTypes) {
      // eslint-disable-next-line no-undef,guard-for-in,no-restricted-syntax
      for (let i = 0; i < fileTypes.length; i += 1) {
        const aType = fileTypes[i];
        this.metadatasType[this.metadatasType
          .findIndex(elmt => elmt.tagName === aType)].isDisabled = true;
      }
    },
    applyConfForUpdate(metadata) {
      this.isUpdate = true;

      const indexExistingType = this.metadatasType.findIndex(elmt => elmt.tagName ===
        metadata.metadata.tagName);

      if (indexExistingType > -1) {
        this.metadatasType[indexExistingType].isDisabled = false;
        // le select a le value sur l'id
        this.metaValueSelect = this.metadatasType[indexExistingType].id;
        this.metadataWithPosition.hasPrefix = metadata.hasPrefix;
        this.metadataWithPosition.hasRegex = metadata.hasRegex;
        this.metadataWithPosition.prefixValue = metadata.prefixValue;
        this.metadataWithPosition.regexValue = metadata.regexValue;
        this.metadataWithPosition.testedValue = metadata.testedValue;
        this.metadataWithPosition.transformPatterns = metadata.transformPatterns;
      }
    },
    applyResult(result) {
      if (result.code === 1000 && result.data.result.length > 0) {
        this.metadataWithPosition.testedValue = result.data.result;
        this.testedNoContent = false;
        this.tested = true;
      } else {
        // no content
        this.tested = false;
        this.testedNoContent = true;
      }
    },

    resetTested() {
      if (this.tested || this.testedNoContent) {
        this.testedNoContent = false;
        this.tested = false;
      }
    },

    getCroppedImageHeight() {
      return `${this.location.height}px`;
    },

    getCroppedImageWidth() {
      return `${this.location.width}px`;
    },

    getLocation() {
      return this.location;
    },

    setCroppedImg() {
      return this.croppedSrcRef;
    },

    testMetadata() {
      this.loadingTest = true;
      this.validateForm(() => {
        const formData = new FormData();
        const file = this.$parent.files[0];
        const metadata = this.metadataWithPosition;
        const pageNumber = this.$parent.currenPdfPage;

        formData.append('pdf', file);

        const meta = {
          tagName: 'test', // pour un simple test, pas besoin de son id
          location: this.getLocation(),
          pageNumber,
        };
        if (metadata.hasPrefix) {
          meta.prefix = metadata.prefixValue;
        } else {
          meta.prefix = undefined;
          metadata.prefixValue = '';
        }
        if (metadata.hasRegex) {
          meta.regex = metadata.regexValue;
        } else {
          meta.regex = undefined;
          metadata.regexValue = '';
        }

        for (let i = metadata.transformPatterns.length - 1; i >= 0; i -= 1) {
          const m = metadata.transformPatterns[i];
          if (m.lookFor.length === 0 && m.replaceWith.length === 0) {
            metadata.transformPatterns.splice(i, 1);
          }
        }

        // pas besoin de if car liste
        meta.transformPatterns = metadata.transformPatterns;

        formData.append('metadatas', JSON.stringify(meta));
        this.apiTestMetadata(formData)
          .then((result) => {
            this.loadingTest = false;
            this.applyResult(result.data);
          }, (error) => {
            this.loadingTest = false;
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log('error.response');
              console.log(error.response.data);
              console.log(error.response.status);
              if (error.response.status === 400) {
                alert('Veuillez selectionner une zone du PDF');
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log('error.request');
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('error.message');
              console.log('Error', error.message);
            }
            console.log(error.config);
          });
      });
    },

    validateForm(callback) {
      this.$validator.validateAll().then((success) => {
        if (success) {
          callback();
        } else {
          console.log('form not valid');
        }
      });
    },

    saveMetadata() {
      const index =
        this.metadatasType.findIndex(el => el.id === this.metaValueSelect);
      this.metadataWithPosition.metadata = this.metadatasType[index];
      this.metadataWithPosition.location = this.getLocation();
      this.metadataWithPosition.pageNumber = this.$parent.currenPdfPage;

      console.log(`saving this type => ${JSON.stringify(this.metadatasType[index])}`);

      this.metadatasType[index].isDisabled = true;
      // console.log(`current id to push : ${this.metadataWithPosition
      // .metadata.id}, instance: ${typeof this.metadataWithPosition.metadata.id}`);
      if (this.isUpdate) {
        const indexTag = this.$parent.resources
          .metadatas
          .findIndex(el => el.metadata.tagName === this.metadataWithPosition.metadata.tagName);
        console.log(indexTag);
        if (indexTag !== -1) { // pas le meme
          console.log('updating same taagName as before');
          console.log(JSON.stringify(this.metadataWithPosition));
          this.$parent.resources.metadatas[indexTag] = Object.assign({}, this.metadataWithPosition);
        } else {
          this.$parent.resources.metadatas.push(Object.assign({}, this.metadataWithPosition));
        }
      } else {
        this.$parent.resources.metadatas.push(Object.assign({}, this.metadataWithPosition));
      }

      this.resetForm();
    },

    resetForm() {
      this.metadataWithPosition = this.metadataWithPositionModel;

      this.metaValueSelect = -1;
      this.$parent.image.imgCrop = '';

      // clear form errors
      this.errors.clear();
      this.tested = false;
      this.isUpdate = false;

      eventBus.$emit('resetCroppedArea');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MetadataAdder.vue